import { render, staticRenderFns } from "./CustomerRequestLogs.vue?vue&type=template&id=5535e2e2&"
import script from "./CustomerRequestLogs.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestLogs.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRequestLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5535e2e2')) {
      api.createRecord('5535e2e2', component.options)
    } else {
      api.reload('5535e2e2', component.options)
    }
    module.hot.accept("./CustomerRequestLogs.vue?vue&type=template&id=5535e2e2&", function () {
      api.rerender('5535e2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Requests/CustomerRequestLogs.vue"
export default component.exports